/**
 * LLM / BYOK settings API service (SPEC §1.10-§1.11).
 */

import type {
  ByokStatus,
  LLMModel,
  TierConfig,
  TierConfigUpdate,
} from '../types/llmSettings';
import { createHeaders } from './apiClient';
import { handleResponse } from './httpResponse';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export async function getByokStatus(): Promise<ByokStatus> {
  const response = await fetch(`${API_BASE_URL}/api/llm/byok`, {
    method: 'GET',
    headers: createHeaders(),
  });
  return handleResponse<ByokStatus>(response);
}

export async function connectByokKey(apiKey: string): Promise<ByokStatus> {
  const response = await fetch(`${API_BASE_URL}/api/llm/byok`, {
    method: 'PUT',
    headers: createHeaders(),
    body: JSON.stringify({ api_key: apiKey }),
  });
  return handleResponse<ByokStatus>(response);
}

export async function disconnectByokKey(): Promise<ByokStatus> {
  const response = await fetch(`${API_BASE_URL}/api/llm/byok`, {
    method: 'DELETE',
    headers: createHeaders(),
  });
  return handleResponse<ByokStatus>(response);
}

export async function listModels(): Promise<LLMModel[]> {
  const response = await fetch(`${API_BASE_URL}/api/llm/models`, {
    method: 'GET',
    headers: createHeaders(),
  });
  return handleResponse<LLMModel[]>(response);
}

export async function getTierConfig(): Promise<TierConfig> {
  const response = await fetch(`${API_BASE_URL}/api/llm/tier-config`, {
    method: 'GET',
    headers: createHeaders(),
  });
  return handleResponse<TierConfig>(response);
}

export async function updateTierConfig(
  update: TierConfigUpdate
): Promise<TierConfig> {
  const response = await fetch(`${API_BASE_URL}/api/llm/tier-config`, {
    method: 'PUT',
    headers: createHeaders(),
    body: JSON.stringify(update),
  });
  return handleResponse<TierConfig>(response);
}
